import http from '@monolith/legacy/services/api/http';
import { BoutiqueApiResponse } from '../types/api-response';

export const getBoutique = async (name: string): Promise<BoutiqueApiResponse> => {
  const { data } = await http().get<BoutiqueApiResponse>(`/api/boutique/${name}`);
  return data;
};
